import styles from './LegitScriptBanner.module.css';

export default function LegitScriptBanner({ className }) {
    return (
        <div className={`${styles.legitscriptBannerContainer} ${className}`}>
            <div className={`${styles.legitscriptBanner}`}>
                <div className={styles.legitscriptContent}>
                    <a href="https://www.legitscript.com/websites/?checker_keywords=tb2.health" target="_blank" title="Verify LegitScript Approval for www.tb2.health">
                        <img src="https://static.legitscript.com/seals/18502077.png" alt="Verify Approval for www.tb2.health" className={styles.legitscriptLogo}/>
                    </a>
                    <span className={styles.legitscriptText}>TB2 is now LegitScript Certified - the highest standard for online healthcare.</span>
                </div>
            </div>
        </div>
    )
}